import { useState, useEffect } from "react";

const useInternetStatus = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [message, setMessage] = useState("");

  const updateOnlineStatus = () => {
    const online = navigator.onLine;
    setIsOnline(online);
    setMessage(
      online
        ? "Internet connection is restored"
        : "Internet connection is disconnected"
    );
  };

  useEffect(() => {
    window.addEventListener("online", updateOnlineStatus);
    window.addEventListener("offline", updateOnlineStatus);

    return () => {
      window.removeEventListener("online", updateOnlineStatus);
      window.removeEventListener("offline", updateOnlineStatus);
    };
  }, []);

  return { isOnline, message };
};

export default useInternetStatus;
